import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subject, Subscription} from 'rxjs';
import {NewsService} from '../../shared/service/news/news.service';
import {ErrorHandlingService} from '../../shared/service/error-handling/error-handling.service';
import {NewsItem} from '../../shared/model/news-item';
import {ErrorInfo} from '../../shared/model/error-info';
import {environment} from '../../../../environments/environment';
import {TranslateService, TranslatePipe} from '@ngx-translate/core';
import {HttpStatusCode} from '@angular/common/http';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {ErrorBoxComponent} from '../error-box/error-box.component';
import {MatIcon} from '@angular/material/icon';
import {MatMiniFabButton, MatButton} from '@angular/material/button';
import {AsyncPipe} from '@angular/common';
import {AdobeTrackingService} from '@datev/ngx-adobe-tracking';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogContent} from '@angular/material/dialog';
import {HtmlViewerComponent} from '../html-viewer/html-viewer.component';


@Component({
    selector: 'myupdates-announcement',
    templateUrl: './announcement.component.html',
    styleUrls: ['./announcement.component.scss'],
  imports: [MatMiniFabButton, MatIcon, MatButton, ErrorBoxComponent, MatProgressSpinner,
    AsyncPipe, TranslatePipe, MatDialogContent, MatDialogClose, HtmlViewerComponent]
})
export class AnnouncementComponent implements OnInit, OnDestroy {

  newsItem$?: Observable<NewsItem>;
  errorInfo$: Observable<ErrorInfo>;
  documentViewerError$ = new Subject<boolean>();

  dataRequestErrorTitle = '';
  dataRequestErrorText = '';
  dataRequestErrorServiceTimeNotice = true;
  documentViewerErrorTitle = '';
  documentViewerErrorText = '';
  documentViewerErrorServiceTimeNotice = true;

  private readonly errorGeneralTitleKey = 'announcement.error_general_title';
  private readonly errorGeneralTextKey = 'announcement.error_general_text';
  private readonly errorOutdatedDocumentTitleKey = 'announcement.error_outdated_document_title';
  private readonly errorOutdatedDocumentTextKey = 'announcement.error_outdated_document_text';

  private readonly errorSubscription: Subscription;

  constructor(private readonly adobeTrackingService: AdobeTrackingService,
              private readonly newsService: NewsService,
              private readonly errorHandlingService: ErrorHandlingService,
              private readonly translate: TranslateService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              @Inject('Window') private readonly window: Window) {
    this.errorInfo$ = this.errorHandlingService.errorStream$;
    this.errorSubscription = this.errorInfo$.subscribe(error => {
      if (error.errorCode === HttpStatusCode.NotFound) {
        this.translate.get([this.errorOutdatedDocumentTitleKey, this.errorOutdatedDocumentTextKey]).subscribe(translation => {
          this.dataRequestErrorTitle = translation[this.errorOutdatedDocumentTitleKey];
          this.dataRequestErrorText = translation[this.errorOutdatedDocumentTextKey];
        });
        this.dataRequestErrorServiceTimeNotice = false;
      } else {
        this.translate.get([this.errorGeneralTitleKey, this.errorGeneralTextKey]).subscribe(translation => {
          this.dataRequestErrorTitle = translation[this.errorGeneralTitleKey];
          this.dataRequestErrorText = translation[this.errorGeneralTextKey];
        });
        this.dataRequestErrorServiceTimeNotice = true;
      }
    });
  }

  ngOnInit(): void {
    this.newsItem$ = this.errorHandlingService.bindErrorHandling(this.newsService.getNewsItemById(this.data.newsItemId));
  }

  ngOnDestroy(): void {
    this.errorSubscription?.unsubscribe();
  }

  shareByMail(newsItem: NewsItem | null): void {
    if (!newsItem) {
      return;
    }

    // Adobe Analytics Einbindung
    this.adobeTrackingService.publishClickEvent('Startseite:Dokument:Teilen');

    const mailSubject = `Leseempfehlung \\ ${newsItem.detail.title} \\ DATEV MyUpdates`;
    const mailBody = `Ich möchte Ihnen den folgenden Beitrag in DATEV MyUpdates empfehlen:` +
      `%0A${newsItem.detail.title}%0A${environment.entryPoint}delivery/all-items/${newsItem.id}%0A%0A` +
      `Mit freundlichem Gruß`;

    this.window.location.href = `mailto:?subject=${mailSubject}&body=${mailBody}`;
  }

}
